var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyyellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 0H8.25C7.00781 0 5.99531 1.02188 6.04219 2.25938C6.05156 2.50781 6.06094 2.75625 6.075 3H1.125C0.501562 3 0 3.50156 0 4.125C0 8.46562 1.57031 11.4844 3.67969 13.5328C5.75625 15.5531 8.2875 16.5703 10.1531 17.0859C11.25 17.3906 12 18.3047 12 19.2234C12 20.2031 11.2031 21 10.2234 21H9C8.17031 21 7.5 21.6703 7.5 22.5C7.5 23.3297 8.17031 24 9 24H18C18.8297 24 19.5 23.3297 19.5 22.5C19.5 21.6703 18.8297 21 18 21H16.7766C15.7969 21 15 20.2031 15 19.2234C15 18.3047 15.7453 17.3859 16.8469 17.0859C18.7172 16.5703 21.2484 15.5531 23.325 13.5328C25.4297 11.4844 27 8.46562 27 4.125C27 3.50156 26.4984 3 25.875 3H20.925C20.9391 2.75625 20.9484 2.5125 20.9578 2.25938C21.0047 1.02188 19.9922 0 18.75 0ZM2.29219 5.25H6.24844C6.675 9.47344 7.61719 12.2953 8.68125 14.1844C7.51406 13.6688 6.3 12.9422 5.25 11.9203C3.75 10.4625 2.53125 8.35781 2.29688 5.25H2.29219ZM21.7547 11.9203C20.7047 12.9422 19.4906 13.6688 18.3234 14.1844C19.3875 12.2953 20.3297 9.47344 20.7562 5.25H24.7125C24.4734 8.35781 23.2547 10.4625 21.7594 11.9203H21.7547Z",
    fill: "#FFCD05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyyellow);
export default __webpack_public_path__ + "static/media/trophy yellow.2a05f60534e7458870b5bf24fecbd76f.svg";
export { ForwardRef as ReactComponent };